// LoginPage.js

import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './common';
import './LoginPage.css';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const didColdReset = useRef(false);

    useEffect(() => {
        if (didColdReset.current) return;
        didColdReset.current = true;
        localStorage.clear();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');

        try {
            const { data, error } = await supabase.auth.signInWithPassword({
                email,
                password,
            });

            if (error) {
                throw error;
            }

            if (data.session) {
                await completeLogin(data.session, data.user);
            }
        } catch (error) {
            setError(error.message);
            setLoading(false);
        }
    };

    const completeLogin = async (session, user) => {
        localStorage.setItem('jwtToken', session.access_token);
        localStorage.setItem('refreshToken', session.refresh_token);
        localStorage.setItem('user', JSON.stringify(user));
        // Redirect to the originally requested page, or home
        const returnTo = sessionStorage.getItem('returnTo') || '/';
        sessionStorage.removeItem('returnTo');
        window.location.href = returnTo;
    };

    return (
        <div style={{ backgroundColor: '#F9F8F6', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="login-container">
                <h2>Log In</h2>
                {error && <p className="error-message">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <>
                        <div className="input-group">
                            <label htmlFor="username">Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                    </>
                    <div className="submit-group">
                        <button type="submit" disabled={loading}>
                            {loading ? 'Verifying...' : 'Log In'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;